<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
        <ng-container *ngFor="let item of breadcrumbs; let last = last">
            <ng-container *ngIf="last">
                <strong *tuiItem tuiFade>
                    {{ item }}
                </strong>
            </ng-container>
            <ng-container *ngIf="!last">
                <button *tuiItem tuiLink type="button">
                    {{ item }}
                </button>
            </ng-container>
        </ng-container>
    </tui-breadcrumbs>

    <button [routerLink]="['/admin/roles/add-edit']" appearance="secondary" tuiButton type="button"
        style="border: 2px solid #E5E7EA; font-weight: 800;" [appDisableUnlessPermission]="'ROLE_CREATE'">
        Add New Role
    </button>
</nav>

<div *ngIf="isLoading" class="h-[400px]">
    <tui-loader />
</div>

<div *ngIf="!isLoading"
    class="w-full mt-5 md:overflow-x-scroll lg:overflow-x-scroll xl:overflow-x-scroll 2xl:overflow-x-hidden">
    <table tuiTable [size]="size" [style.width.rem]="120">
        <thead>
            <tr>
                <th tuiTh style="padding: 0;padding-left: 10px; background-color: #F9FBFF;">Role Name</th>
                <th tuiTh style="padding: 0;padding-left: 10px; background-color: #F9FBFF;">Permissions</th>
                <th tuiTh style="padding: 0;padding-left: 10px; background-color: #F9FBFF;">Users</th>
                <th tuiTh style="padding: 0;padding-left: 10px; background-color: #F9FBFF;">Actions</th>
            </tr>
        </thead>

        <tbody tuiTbody>
            <tr *ngFor="let item of listOfRoles">
                <td tuiTd style="padding-top: 0px;padding-bottom: 0px;">
                    <div [tuiCell]="size">
                        <p class="text-[#526ED3] text-sm cursor-pointer">{{
                            item.name }}</p>
                    </div>
                </td>
                <td tuiTd style="padding-top: 0px;padding-bottom: 0px;">
                    <div [tuiCell]="size">
                        <p class="text-[#191C30E5] text-sm">{{ item.permissions }}</p>
                    </div>
                </td>
                <td tuiTd style="padding-top: 0px;padding-bottom: 0px;">
                    <div [tuiCell]="size">
                        <p class="text-[#191C30E5] text-sm">{{ item.users }}</p>
                    </div>
                </td>

                <td tuiTd style="padding-top: 0px;padding-bottom: 0px;">
                    <span tuiStatus>
                        <!-- <p [routerLink]="['/admin/user/', item._id]"
                            class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer">
                            View
                        </p> -->
                        <p [routerLink]="['/admin/roles/add-edit', item._id]"
                            class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer">
                            Edit
                        </p>
                        <!-- <div>
                            <button appearance="action" iconStart="@tui.ellipsis" size="xs" tuiIconButton type="button"
                                [tuiAppearanceState]="open ? 'hover' : null" [tuiDropdown]="content"
                                [(tuiDropdownOpen)]="open">
                                More
                            </button>
                            <ng-template #content>
                                <tui-data-list tuiDataListDropdownManager [size]="openDropdownsize">
                                    <button style="color: black;" tuiOption type="button">
                                        My Account
                                    </button>
                                    <button style="color: black;" tuiOption type="button">
                                        Log Out
                                    </button>
                                </tui-data-list>
                            </ng-template>
                        </div> -->
                    </span>
                </td>
            </tr>
        </tbody>

    </table>
</div>

<!-- Pagination Controls -->
<div class="flex justify-end items-center mt-5">
    <tui-pagination [index]="pageIndex - 1" [length]="getPageCount()" (indexChange)="onPageChange($event + 1)">
    </tui-pagination>
</div>
